import React from "react"
import { isShopDisabled } from "@utils/isShopDisabled"

import * as s from "./AddToCartButton.module.scss"

export const AddToCartButton = ({
  title,
  addedTitle,
  className,
  onClick,
  added,
}) => {
  if (isShopDisabled()) {
    return null
  }

  return (
    <button
      role="button"
      className={`${s.AddToCartButton} ${className ? className : ""} ${
        added ? s.AddToCartButton___added : ""
      }`}
      onClick={onClick}
    >
      <span>{added ? addedTitle : title}</span>
    </button>
  )
}
